export const namePositionReducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_NAME':
            return {
                ...state,
                name: action.name
            }
        case 'UPDATE_POSITION':
            return {
                ...state,
                position: action.position
            }
        default:
            return state;
    }
}
